import {ChangeDetectionStrategy, Component, input, ViewEncapsulation} from '@angular/core';

@Component({
  selector: 'app-cpru-survey-score',
  templateUrl: './cpru-survey-score.component.html',
  styleUrls: ['./cpru-survey-score.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CpruSurveyScoreComponent {
  score = input<number>(null);
}
